import { queryClient } from '@/lib/queryClient'
import {
  getCachedCommentsActivityIds,
  getCategoriesFeedActivityIds,
  getExclusiveFeedActivityIds,
  getReactionIdsToRemove,
  getTimelineFeedActivityIds,
  getUsersFeedActivityIds,
} from './utils'

import { QueryKeys } from '@/enums'

export const removeRedundantCachedReactions = () => {
  const timelineFeedActivityIds = getTimelineFeedActivityIds()
  const exclusiveFeedActivityIds = getExclusiveFeedActivityIds()
  const categoriesFeedActivityIds = getCategoriesFeedActivityIds()
  const userFeedActivityIds = getUsersFeedActivityIds()
  const cachedCommentsActivityIds = getCachedCommentsActivityIds()

  const activitiesIdSet = new Set([
    ...timelineFeedActivityIds,
    ...exclusiveFeedActivityIds,
    ...categoriesFeedActivityIds,
    ...userFeedActivityIds,
    ...cachedCommentsActivityIds,
  ])
  const reactionIdsToRemove = getReactionIdsToRemove(activitiesIdSet)

  reactionIdsToRemove.forEach((reactionActivityId) => {
    queryClient.removeQueries({
      queryKey: [QueryKeys.Reaction, reactionActivityId],
    })
  })
}
